import React from 'react';
import { useChartReflow } from '../../../../hooks/useChartReflow';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Card } from '../../../../../../CommonComponents/OPL/Card/Card';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { LegendKey } from '../../../../../../CommonComponents/OPL/charts/LegendKey/LegendKey';
import { DecumulationChart } from '../../components/DecumulationChart/DecumulationChart';
import { useDecumulationGoalQuery } from '../../../../../api/useDecumulationGoalQuery';
import { FullPageLoading } from '../../../../../../CommonComponents/OPL/FullpageLoading/FullPageLoading';
import { ErrorState } from '../../../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { HtmlTable } from '../../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import Spinner from '../../../../../../CommonComponents/Spinner';

export const Overview = () => {
  const { isLoading, isFetching, isError, refetch, data } = useDecumulationGoalQuery();

  const { chartRef } = useChartReflow();

  if (isLoading) {
    return <FullPageLoading text="Loading..." size="medium" />;
  }

  if (isError) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" mt="56">
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (!data) {
    throw new Error('No data for the decumulation chart');
  }

  const { chartData, whatIfPlanImpact } = data;

  return (
    <>
      {isFetching && <Spinner />}

      <Card mt="32">
        <Box p={16}>
          <Text variant="cardTitle" mb="24">
            Decumulation
          </Text>

          <DecumulationChart ref={chartRef} data={chartData} />

          <Box display="flex" justifyContent="center">
            <LegendKey text="50% Confidence" />
            <LegendKey
              dotBorderColor="primary.500"
              dotColor="primary.100"
              ml="24"
              text="90% Confidence"
            />
          </Box>
        </Box>

        <HtmlTable variant="embedded">
          <table>
            <thead>
              <tr>
                {['Plan Impact', 'Current', 'Proposed'].map(heading => (
                  <th key={heading}>
                    <Text variant="smallCaps" textAlign="left">
                      {heading}
                    </Text>
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {whatIfPlanImpact.map(row => (
                <tr key={row.Label}>
                  <td>
                    <Text fontWeight={500}>{row.Label}</Text>
                  </td>
                  <td>
                    <Text fontWeight={500}>{row.Current}</Text>
                  </td>
                  <td>
                    <Text fontWeight={500}>{row.Proposed}</Text>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </HtmlTable>
      </Card>
    </>
  );
};
